const linkInvitationUserCopiedToClipboard = {
  toastr: 'Link',
  toastr1: 'Link copied to transfer area'
};

export default linkInvitationUserCopiedToClipboard;